import * as React from 'react';

import { ContainerLayout, ReadMoreLink } from '../../components';
import { FormContext } from '../../utils/formContext';
import { FormFailedContent, ChangeAnswerDesktop, ChangeAnswerMobile } from './components';
import { EContainerTypes } from '../../types';
import { useDeviceType } from '@cian/ui-kit';
import { NBSP } from '../../../../constants/symbols';
import { useE2eLabelTracking } from '../../hooks';
import { trackChangeAnswerClick } from '../../utils/tracking';

const FAIL_REASON_TEXT: Partial<Record<EContainerTypes, React.ReactNode>> = {
  [EContainerTypes.IsMorgageQuestion]: (
    <>
      Объект не подходит для сделки, потому что находится в залоге.
      <br />
      Мы не сможем добавить значок сервиса, но ваше объявление и без него выглядит прекрасно!{NBSP}
    </>
  ),
  [EContainerTypes.OwnerCitizenshipQuestion]: (
    <>
      Объект не подходит для онлайн-сделки, потому что не все собственники — граждане РФ.
      <br />
      Мы не сможем добавить значок сервиса, но ваше объявление и без него выглядит прекрасно!{NBSP}
    </>
  ),
  [EContainerTypes.MaternityCapitalQuestion]: (
    <>
      Объект не подходит для онлайн-сделки, потому что его приобрели с помощью материнского капитала.
      <br />
      Мы не сможем добавить значок сервиса, но ваше объявление и без него выглядит прекрасно!{NBSP}
    </>
  ),
  [EContainerTypes.EncumbranceWillBeRemoved]: (
    <>
      Объект не подходит для сделки: мы проводим сделки с недвижимостью в залоге, только если обременение можно снять во
      время сделки.
      <br />
      Мы пока не сможем добавить значок сервиса, но ваше объявление и без него выглядит прекрасно!{NBSP}
    </>
  ),
};

export const FormFailedContainer: React.FC = () => {
  const formContext = React.useContext(FormContext);
  const isMobile = useDeviceType() === 'phone';
  const ChangeAnswer = isMobile ? ChangeAnswerMobile : ChangeAnswerDesktop;
  const onTrackChangeAnswerClick = useE2eLabelTracking(trackChangeAnswerClick);

  const onChangeAnswerClick = () => {
    onTrackChangeAnswerClick({ questionName: formContext.previousStep });
    formContext.onPreviousStep();
  };

  return (
    <ContainerLayout
      title="С объектом пока нельзя провести онлайн-сделку"
      content={
        <FormFailedContent>
          {FAIL_REASON_TEXT[formContext.previousStep]}
          {isMobile && <ReadMoreLink inline theme="not-filled" />}
        </FormFailedContent>
      }
      actions={
        <>
          {!isMobile && <ReadMoreLink theme="filled" />}
          <ChangeAnswer onClick={onChangeAnswerClick} />
        </>
      }
      isWithRightSideImage={false}
      isWithRingLabelImage={false}
    />
  );
};
